import { Component, OnInit } from '@angular/core';
import { Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';

import { CoordinateSystem } from 'app/models';
import { FileType } from 'app/models/enums';
import { CsvService, DownloadService, HttpService, ReportService, ShapefileService } from 'app/services';
import { DownloadExportTaskBase } from 'app/shared/export/downloadExportTaskBase';

@Component({
  selector: 'app-export-others',
  templateUrl: './export-others.component.html',
  styleUrls: ['./export-others.component.scss']
})
export class ExportOthersComponent extends DownloadExportTaskBase implements OnInit {
  constructor(
    private readonly reportService: ReportService,
    private readonly shapefileService: ShapefileService,
    private readonly csvService: CsvService,
    httpService: HttpService,
    downloadService: DownloadService
  ) {
    super(httpService, downloadService);
  }

  ngOnInit() {}

  public downloadFile(fileType: string): void {
    this.setDownloading(true);
    this.errorMessages = [];
    let downloadFile: Observable<Response>;

    console.log(fileType);

    switch (fileType) {
      case FileType.KPI:
        downloadFile = this.reportService.downloadReport('KPI');
        this.handleTaskAsync(downloadFile);
        break;
      case FileType.VILD:
        downloadFile = this.reportService.downloadReport('VILD');
        this.handleTaskAsync(downloadFile);
        break;
      case FileType.fcderrorscsv:
        downloadFile = this.csvService.downloadCsvFcdErrors();
        this.handleTaskAsync(downloadFile);
        break;
    }
  }

  public downloadHistoricShapefile(coordinateSystem: CoordinateSystem): void {
    this.setDownloading(true);
    this.errorMessages = [];
    let downloadFile: Observable<Response>;

    downloadFile = this.shapefileService.downloadHistoricShapefile(coordinateSystem);
    this.handleTaskAsync(downloadFile);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/export/others/export-others.component.ts